'use strict';

export default angular
  .module('maestro.filters.fileSize', [])

  .filter('fileSize', function($filter) {
    let $t = $filter('translate');
    return function(size) {
      if (!size || size < 0) {
        return $t('global:common.Kb', {
          val: 0
        });
      }
      let kb = parseFloat(size / 1024);
      let mb = parseFloat(kb / 1024);
      let gb = parseFloat(mb / 1024);
      if (gb >= 1) {
        return $t('common.Gb', {
          val: parseFloat(gb.toFixed(2))
        });
      } else if (mb >= 1) {
        return $t('common.Mb', {
          val: parseFloat(mb.toFixed(2))
        });
      } else {
        return $t('common.Kb', {
          val: kb.toFixed(0)
        });
      }
    };
  })

  .name;
